import React, { Component } from 'react';
import Radium, { Style } from 'radium';
import autobind from 'autobind-decorator';

class Popup extends Component {
  static styles = {};

  @autobind
  onBackDropClick(e) {
    e.stopPropagation();
    if (this.props.modal === true) return false;
    this.hidePopup();
    return false;
  }

  @autobind
  hidePopup() {
    this.props.hidePopup();
  }

  @autobind
  stopBackDropClick(e) {
    e.stopPropagation();
  }

  render() {
    const styles = Popup.styles;
    return (
      <div
        className="popUpMainContainer"
        style={[
          this.props.showPopup ? styles.displayBlock : styles.displayNone,
          this.props.mainWrapperStyle
        ]}
        onClick={e => this.onBackDropClick(e)}
      >
        <div
          style={[styles.popUpInnerWrapper, this.props.popUpInnerWrapper]}
          onClick={e => this.stopBackDropClick(e)}
        >
          <div
            className="closeIcon"
            style={
              (this.props.showCloseButton ? styles.displayInlineBlock : styles.displayNone,
              this.props.closeButtonStyle)
            }
            onClick={this.hidePopup}
          />
          {this.props.children}
        </div>
        <Style rules={styles.classBased} scopeSelector=".popUpMainContainer" />
      </div>
    );
  }
}

Popup.defaultProps = {
  modal: false
};

Popup.styles = {
  classBased: {
    '': {
      background: 'rgba(0,0,0,0.5)',
      position: 'fixed',
      left: '0',
      width: '100%',
      top: '0',
      bottom: '0',
      zIndex: '1001',
      display: 'flex',
      alignItems: 'center'
    },
    '.closeIcon': {
      width: '26px',
      height: '26px',
      display: 'inline-block',
      position: 'absolute',
      top: '16px',
      right: '22px',
      overflow: 'hidden',
      cursor: 'pointer'
    },
    '.closeIcon:after': {
      content: '',
      position: 'absolute',
      height: '2px',
      width: '100%',
      top: '50%',
      left: '0px',
      marginTop: '-1px',
      background: '#767E86',
      transform: 'rotate(45deg)'
    },
    '.closeIcon:before': {
      content: '',
      position: 'absolute',
      height: '2px',
      width: '100%',
      top: '50%',
      left: '0px',
      marginTop: '-1px',
      background: '#767E86',
      transform: 'rotate(-45deg)'
    }
  },
  displayNone: {
    display: 'none'
  },
  display: {
    display: 'block'
  },
  displayInlineBlock: {
    display: 'inline-block'
  },
  popUpInnerWrapper: {
    minWidth: '100px',
    minHeight: '100px',
    margin: '0px auto',
    padding: '20px',
    border: '1px solid #DBE2E8',
    borderRadius: '3px',
    boxShadow: 'rgba(0,0,0,0.3) 0 2px 14px',
    background: 'white',
    position: 'relative'
  }
};

export default Radium(Popup);
